export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'SET_SDK': {
      return payload;
    }
    default:
      return state;
  }
};
